


















































































































































































































































































































































































































































import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import Service from "@/services/IdentitasBayiBaruLahir";
import IdentitasBayiBaruLahirStore from "@/store/modules/IdentitasBayiBaruLahirStore";
import RegisterKunjungan from "@/store/modules/RegisterKunjungan";
import { fetchApgarBbl, bblKomponenToIdentitas } from "@/utils/apgarBbl";
import { identitasIbuFromPasien } from "@/utils/identitasBbl";
import { storePasien } from "@/store/modules/pasien";
import { storePerawat } from "@/store/modules/perawat";
import { userModule } from "@/store/modules/user";

function emptyApgar() {
  return {
    frekuensi_jantung: null,
    usaha_bernafas: null,
    tonus_otot: null,
    iritabilitas_refleks: null,
    warna_kulit: null,
    jumlah: null
  };
}

function emptyObstetriRow() {
  return {
    tahun: "",
    jenis_persalinan: "",
    berat_bayi: "",
    jenis_kelamin: "",
    keadaan_bayi: "",
    keadaan_kehamilan: "",
    lain_lain: ""
  };
}

@Component
export default class IdentitasBayiBaruLahirPage extends Vue {
  @Prop() register: string;
  @Prop() rm: string;

  get canSave(): boolean {
    const action = this.recordId ? "edit" : "create";
    return userModule.canAccessForm("identitas_bbl", action);
  }

  loading = false;
  saving = false;
  recordId: number = null;
  menuTanggalLahir = false;
  menuHpm = false;
  menuHpl = false;
  capKakiFile: File = null;
  capKakiPreview = "";
  withSignature = false;

  form = {
    nama_ibu: "",
    umur_ibu: null as number | null,
    pekerjaan_ibu: "",
    pekerjaan_ibu_lainnya: "",
    pendidikan_ibu: "",
    agama_ibu: "",
    ayah_tidak_ada: false,
    nama_ayah: "",
    umur_ayah: null as number | null,
    pekerjaan_ayah: "",
    pekerjaan_ayah_lainnya: "",
    pendidikan_ayah: "",
    agama_ayah: "",
    nama_bayi: "",
    tanggal_lahir: "",
    jenis_kelamin: "",
    jam_kelahiran: "",
    jenis_kelahiran: "",
    status_kelahiran: "",
    alamat: "",
    berat_badan: null as number | null,
    panjang_badan: null as number | null,
    lingkar_kepala: null as number | null,
    lingkar_dada: null as number | null,
    lingkar_lengan_atas: null as number | null,
    uub_transversal: null as number | null,
    uub_sagital: null as number | null,
    apgar_1_menit: emptyApgar(),
    apgar_5_menit: emptyApgar(),
    apgar_2_jam: emptyApgar(),
    gravida: null as number | null,
    paritas: null as number | null,
    abortus: null as number | null,
    anak_hidup: null as number | null,
    umur_kehamilan: "",
    hpm: "",
    hpl: "",
    anc_jumlah: null as number | null,
    anc_tempat: "",
    anc_keteraturan: "",
    anc_sejak_minggu: null as number | null,
    penyakit_komplikasi: "",
    riwayat_pengobatan: "",
    hb_terakhir: null as number | null,
    golongan_darah: "",
    tindakan_pada_ibu: "",
    riwayat_obstetri: Array.from({ length: 6 }, emptyObstetriRow),
    persalinan_di: "",
    ditolong_oleh: "",
    cara_persalinan: "",
    atas_indikasi: "",
    lama_persalinan: { kala_1: "", kala_2: "", kala_3: "", jumlah: "" },
    ketuban_pecah: { tanggal: "", jam: "", warna: "", bau: "", keterangan: "" },
    plasenta: { berat: "", ukuran: "" },
    perdarahan: { kala_1: "", kala_2: "", kala_3: "", kala_4: "", jumlah: "" },
    cap_kaki: "",
    dokter_id: "",
    perawat_id: ""
  };

  pekerjaanOptions = ["PNS", "TNI", "Swasta", "Pedagang", "Petani", "Buruh", "Lainnya"];
  pendidikanOptions = ["Belum/Tidak Tamat SD", "SD", "SLTP", "SLTA", "Perguruan Tinggi"];
  agamaOptions = ["Islam", "Protestan", "Katolik", "Hindu", "Budha", "Lain-lain"];

  apgarKriteria = [
    { key: "frekuensi_jantung", label: "Frekuensi Jantung" },
    { key: "usaha_bernafas", label: "Usaha Bernafas" },
    { key: "tonus_otot", label: "Tonus Otot" },
    { key: "iritabilitas_refleks", label: "Iritabilitas Refleks" },
    { key: "warna_kulit", label: "Warna Kulit" }
  ];

  get dokterList() {
    const reg = RegisterKunjungan.register;
    if (reg && reg.dokter && reg.dokter.nama) {
      const id = reg.dokter.id || reg.dokter.c_doc_id || "";
      return [{ id, nama: reg.dokter.nama }];
    }
    return [];
  }

  get perawatList() {
    return storePerawat.listPerawat || [];
  }

  mounted() {
    if (!storePerawat.listPerawat.length) {
      storePerawat.actListPerawatall();
    }
    if (this.register) {
      this.loadData();
    }
  }

  async loadData() {
    this.loading = true;
    try {
      await IdentitasBayiBaruLahirStore.getByRegister(this.register);
      const record = IdentitasBayiBaruLahirStore.record;
      if (record) {
        this.recordId = record.id;
        this.populateForm(record);
      } else {
        // Auto-fill dokter dari register jika data baru
        const reg = RegisterKunjungan.register;
        if (reg && reg.dokter) {
          this.form.dokter_id = String(reg.dokter.id || reg.dokter.c_doc_id || "");
        }
        this.prefillIbuFromPasien();
        await this.prefillApgarFromBbl();
      }
    } finally {
      this.loading = false;
    }
  }

  @Prop({ default: false }) isActive!: boolean;

  @Watch("isActive")
  onActiveChanged(val: boolean) {
    if (val && !this.recordId && !this.form.nama_ibu) {
      this.prefillIbuFromPasien();
    }
  }

  prefillIbuFromPasien() {
    const ibu = identitasIbuFromPasien(storePasien.identitasPasien);
    if (!ibu) return;
    if (!this.form.nama_ibu) this.form.nama_ibu = ibu.nama_ibu;
    if (this.form.umur_ibu == null && ibu.umur_ibu !== null) this.form.umur_ibu = ibu.umur_ibu;
    if (!this.form.pekerjaan_ibu && ibu.pekerjaan_ibu) {
      this.form.pekerjaan_ibu = ibu.pekerjaan_ibu;
      if (!this.form.pekerjaan_ibu_lainnya) this.form.pekerjaan_ibu_lainnya = ibu.pekerjaan_ibu_lainnya;
    }
    if (!this.form.pendidikan_ibu && ibu.pendidikan_ibu) this.form.pendidikan_ibu = ibu.pendidikan_ibu;
    if (!this.form.agama_ibu && ibu.agama_ibu) this.form.agama_ibu = ibu.agama_ibu;
    if (!this.form.alamat && ibu.alamat) this.form.alamat = ibu.alamat;
  }

  // IMP-066: isi APGAR 1'/5' dari Asesmen BBL (kolom "2 jam" tetap manual)
  async prefillApgarFromBbl() {
    const a = await fetchApgarBbl(this.register);
    if (!a || !a.komponen) return;
    const map = { apgar_1_menit: "menit_1", apgar_5_menit: "menit_5" };
    Object.keys(map).forEach(field => {
      const cur = this.form[field] || {};
      const terisi = Object.keys(cur).some(
        k => k !== "jumlah" && cur[k] !== null && cur[k] !== undefined
      );
      if (terisi) return;
      this.form[field] = { ...cur, ...bblKomponenToIdentitas(a.komponen[map[field]]) };
    });
    this.hitungApgar();
  }

  populateForm(data) {
    const fields = Object.keys(this.form);
    fields.forEach(key => {
      if (data[key] !== undefined && data[key] !== null) {
        if (key === "riwayat_obstetri") {
          const rows = data[key] || [];
          this.form.riwayat_obstetri = Array.from({ length: 6 }, (_, i) => rows[i] || emptyObstetriRow());
        } else if (typeof this.form[key] === "object" && !Array.isArray(this.form[key]) && this.form[key] !== null) {
          this.form[key] = { ...this.form[key], ...data[key] };
        } else {
          this.form[key] = data[key];
        }
      }
    });
    // Set preview dari server URL
    this.capKakiPreview = data.cap_kaki_url || "";
    // Set withSignature jika dokter/perawat sudah diisi
    this.withSignature = !!(data.dokter_id || data.perawat_id);
  }

  onAyahTidakAdaChange(value: boolean) {
    if (!value) return;
    this.form.nama_ayah = "";
    this.form.umur_ayah = null;
    this.form.pekerjaan_ayah = "";
    this.form.pekerjaan_ayah_lainnya = "";
    this.form.pendidikan_ayah = "";
    this.form.agama_ayah = "";
  }

  hitungApgar() {
    const keys = ["frekuensi_jantung", "usaha_bernafas", "tonus_otot", "iritabilitas_refleks", "warna_kulit"];
    ["apgar_1_menit", "apgar_5_menit", "apgar_2_jam"].forEach(waktu => {
      const vals = keys.map(k => this.form[waktu][k]).filter(v => v !== null && v !== undefined);
      this.form[waktu].jumlah = vals.length > 0 ? vals.reduce((a, b) => a + b, 0) : null;
    });
  }

  hitungPerdarahan() {
    const keys = ["kala_1", "kala_2", "kala_3", "kala_4"];
    const vals = keys.map(k => parseFloat(this.form.perdarahan[k]) || 0);
    this.form.perdarahan.jumlah = vals.reduce((a, b) => a + b, 0).toString();
  }

  hitungLamaPersalinan() {
    const keys = ["kala_1", "kala_2", "kala_3"];
    const vals = keys.map(k => parseFloat(this.form.lama_persalinan[k]) || 0);
    this.form.lama_persalinan.jumlah = vals.reduce((a, b) => a + b, 0).toString();
  }

  onCapKakiChange(file: File) {
    if (!file) return;
    const reader = new FileReader();
    reader.onload = (e) => {
      const base64 = e.target.result as string;
      this.form.cap_kaki = base64;
      this.capKakiPreview = base64;
    };
    reader.readAsDataURL(file);
  }

  getUnitId(): string {
    const register = RegisterKunjungan.register;
    if (register && register.jurnal_ranap && register.jurnal_ranap.length) {
      const last = register.jurnal_ranap[register.jurnal_ranap.length - 1];
      if (last && last.unit) return last.unit.id;
    }
    // Jurnal bangsal hanya dibaca dari cm_i{tahun ini}/{tahun lalu}; bila kosong,
    // pakai unit pada register itu sendiri (server tetap me-resolve bila kosong).
    if (register && register.unit) return String(register.unit);
    return this.$route && this.$route.query && this.$route.query.unit_id
      ? this.$route.query.unit_id.toString()
      : "";
  }

  getPayload() {
    return {
      register_id: this.register,
      pasien_rm: this.rm,
      unit_id: this.getUnitId(),
      with_signature: this.withSignature,
      ...this.form
    };
  }

  async save() {
    this.saving = true;
    try {
      if (this.recordId) {
        await Service.update(this.recordId, this.getPayload());
      } else {
        const res = await Service.create(this.getPayload());
        if (res.data?.status === 1) {
          this.recordId = res.data.data.id;
        }
      }
    } finally {
      this.saving = false;
    }
  }

  async remove() {
    if (!confirm("Apakah Anda yakin ingin menghapus data ini?")) return;
    await Service.destroy(this.recordId);
    this.recordId = null;
    this.resetForm();
  }

  printPdf() {
    Service.print(this.recordId);
  }

  resetForm() {
    this.form = {
      nama_ibu: "", umur_ibu: null, pekerjaan_ibu: "", pekerjaan_ibu_lainnya: "", pendidikan_ibu: "", agama_ibu: "",
      ayah_tidak_ada: false,
      nama_ayah: "", umur_ayah: null, pekerjaan_ayah: "", pekerjaan_ayah_lainnya: "", pendidikan_ayah: "", agama_ayah: "",
      nama_bayi: "", tanggal_lahir: "", jenis_kelamin: "", jam_kelahiran: "", jenis_kelahiran: "", status_kelahiran: "", alamat: "",
      berat_badan: null, panjang_badan: null, lingkar_kepala: null, lingkar_dada: null, lingkar_lengan_atas: null, uub_transversal: null, uub_sagital: null,
      apgar_1_menit: emptyApgar(), apgar_5_menit: emptyApgar(), apgar_2_jam: emptyApgar(),
      gravida: null, paritas: null, abortus: null, anak_hidup: null,
      umur_kehamilan: "", hpm: "", hpl: "", anc_jumlah: null, anc_tempat: "", anc_keteraturan: "", anc_sejak_minggu: null,
      penyakit_komplikasi: "", riwayat_pengobatan: "", hb_terakhir: null, golongan_darah: "",
      tindakan_pada_ibu: "",
      riwayat_obstetri: Array.from({ length: 6 }, emptyObstetriRow),
      persalinan_di: "", ditolong_oleh: "", cara_persalinan: "", atas_indikasi: "",
      lama_persalinan: { kala_1: "", kala_2: "", kala_3: "", jumlah: "" },
      ketuban_pecah: { tanggal: "", jam: "", warna: "", bau: "", keterangan: "" },
      plasenta: { berat: "", ukuran: "" },
      perdarahan: { kala_1: "", kala_2: "", kala_3: "", kala_4: "", jumlah: "" },
      cap_kaki: "",
      dokter_id: "", perawat_id: ""
    };
  }
}
